import { Link } from 'react-router-dom'

/**
 * The Brand page's trail: Brands / market / brand.
 *
 * The market segment appears only when one is applied, so the trail states the
 * scope the page is actually showing rather than implying a market it does not have.
 */
export function BrandBreadcrumb({ marketLabel, brandName }: { marketLabel: string | null; brandName: string }) {
	return (
		<nav
			aria-label="Breadcrumb"
			className="mb-4 flex items-center gap-1.5 font-mono text-ds-2xs uppercase tracking-ds-wider text-ds-text-subtle"
		>
			<Link to="/explore" className="hover:text-ds-text">
				Brands
			</Link>
			{marketLabel ? (
				<>
					<span aria-hidden>/</span>
					<span>{marketLabel}</span>
				</>
			) : null}
			<span aria-hidden>/</span>
			<span className="text-ds-text">{brandName}</span>
		</nav>
	)
}
